import { forwardRef, InputHTMLAttributes } from 'react'
import { cn } from '../../utilities.ts'
import { VariantProps } from 'class-variance-authority'
import { inputVariants } from './inputVariants.tsx'

const SupportedInputTypes = [
  'text',
  'checkbox',
  'number',
  'email',
  'password',
  'tel',
  'date',
]

type InputProps = InputHTMLAttributes<HTMLInputElement> &
  VariantProps<typeof inputVariants>
export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, type = 'text', variant, ...props }, ref) => {
    if (!SupportedInputTypes.includes(type ?? ''))
      throw new Error(`${type} is not a supported Custom-Input type`)
    switch (type) {
      case 'email':
      case 'password':
      case 'tel':
      case 'text':
      case 'date': // treat date like text for styling
        variant = 'text'
        break
      case 'number':
        variant = 'number'
        break
      default:
        variant = 'checkbox'
    }

    return (
      <input
        className={cn(inputVariants({ variant, className }))}
        ref={ref}
        type={type}
        {...props}
      />
    )
  }
)
